import { HttpClient } from '@angular/common/http';
import { ConverterService } from '@core/converter.service';
import { isNilty } from '@core/utils.service';
import { Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

export function cachedArrayGet<T>(cache: GenericArrayCache<T>, endpoint: string): Observable<T[]> {
  if (!isNilty(cache.cachedArray)) {
    return of(cache.cachedArray);
  }

  if (cache.getting) {
    return cache.subject;
  } else {
    cache.getting = true;
    return cache.http.get(endpoint).pipe(
      map((r: T[]) => {
        if (cache.clazz) {
          cache.cachedArray = r.map((it) => cache.converter.fromJSONtoObj(it, cache.clazz));
        } else {
          cache.cachedArray = r;
        }
        cache.subject.next(cache.cachedArray);
        cache.getting = false;
        return cache.cachedArray;
      }),
    );
  }
}

// Clazz is needed for the converter. If not provided, the converter will not be called.
// Clazz must not be provided for primitive types.
export class GenericArrayCache<T> {
  clazz: any;
  http: HttpClient;
  converter: ConverterService;
  cachedArray: T[];
  subject: Subject<T[]>;
  getting = false;

  constructor(http: HttpClient, converter: ConverterService, clazz?: any) {
    this.subject = new Subject<T[]>();
    this.clazz = clazz;
    this.http = http;
    this.converter = converter;
  }

  reset() {
    this.cachedArray = undefined;
    this.getting = false;
  }
}
